import DOMPurify from "dompurify";
import { mediaUrl } from "./api";

export function hashIdx(id) {
  let h = 0;
  for (const ch of String(id)) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return h % 3;
}

export function thumbArt(color, i) {
  i = Math.abs(parseInt(i, 10) || 0);
  if (color === "land") {
    const hues = [["#0d2b24", "#134536", "#52d273"], ["#0c2430", "#0f3d46", "#4ec9b0"], ["#14281c", "#1e4a2c", "#7ade8f"]][i % 3];
    return `<svg viewBox="0 0 400 225" preserveAspectRatio="xMidYMid slice">
      <rect width="400" height="225" fill="${hues[0]}"/><circle cx="${320 - i * 40}" cy="50" r="26" fill="${hues[2]}" opacity=".35"/>
      <path d="M0,225 L0,150 L70,${95 + i * 10} L150,160 L230,${85 + i * 12} L310,155 L400,110 L400,225 Z" fill="${hues[1]}"/>
      <path d="M0,225 L0,185 L90,150 L190,190 L290,145 L400,180 L400,225 Z" fill="${hues[0]}" opacity=".9"/></svg>`;
  }
  const seed = i * 37;
  let nodes = "", wires = "";
  const pts = [[60, 60], [160, 140], [280, 70], [340, 160], [110, 175], [230, 180]];
  pts.forEach((p, j) => {
    const x = p[0] + ((seed * j) % 30), y = p[1] - ((seed * j) % 24);
    nodes += `<rect x="${x - 24}" y="${y - 14}" width="48" height="28" rx="6" fill="#0e1a28" stroke="#38b6ff" stroke-width="1.4" opacity=".9"/>
      <circle cx="${x - 24}" cy="${y}" r="3.5" fill="#52d273"/><circle cx="${x + 24}" cy="${y}" r="3.5" fill="#ff7847"/>`;
    if (j > 0) {
      const px = pts[j - 1][0] + ((seed * (j - 1)) % 30), py = pts[j - 1][1] - ((seed * (j - 1)) % 24);
      wires += `<path d="M${px + 24},${py} C${px + 70},${py} ${x - 70},${y} ${x - 24},${y}" stroke="#38b6ff" stroke-width="1.6" fill="none" opacity=".55"/>`;
    }
  });
  return `<svg viewBox="0 0 400 225" preserveAspectRatio="xMidYMid slice"><rect width="400" height="225" fill="#0b1420"/>
    <g opacity=".14">${Array.from({ length: 10 }, (_, k) => `<line x1="${k * 44}" y1="0" x2="${k * 44}" y2="225" stroke="#274156"/>`).join("")}
    ${Array.from({ length: 6 }, (_, k) => `<line x1="0" y1="${k * 44}" x2="400" y2="${k * 44}" stroke="#274156"/>`).join("")}</g>${wires}${nodes}</svg>`;
}

export const ThumbArt = ({ color = "bp", idx = 0 }) => (
  <div className="artw" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(thumbArt(color, idx), { USE_PROFILES: { svg: true, svgFilters: true } }) }} />
);

export const CourseThumb = ({ course, color }) => (
  course?.thumbnail ? (
    <img src={mediaUrl(course.thumbnail)} alt={course.title || ""} className="artw" data-testid={`course-thumb-${course.id}`}
      style={{ objectFit: "cover", width: "100%", height: "100%" }}
      onError={(e) => { e.currentTarget.style.display = "none"; }} />
  ) : (
    <ThumbArt color={color} idx={hashIdx(course?.id || 0)} />
  )
);

export const Stars = ({ r, className = "stars" }) => (
  <span className={className}>
    {[1, 2, 3, 4, 5].map((i) => (
      <span key={i} className={i <= Math.round(r) ? undefined : "off"}>★</span>
    ))}
  </span>
);

export const fmtCount = (n) => (n >= 1000 ? (n / 1000).toFixed(n >= 10000 ? 0 : 1).replace(".0", "") + "K" : String(n || 0));
